import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { DataService } from 'src/app/services/data.service';

import { CapitalizePipe } from '../../pipes/capitalize.pipe';

@Component({
    selector: 'app-redeemed',
    templateUrl: './redeemed.component.html',
    styleUrls: ['./redeemed.component.scss']
})
export class RedeemedComponent implements OnInit {
    public contract = this.dataService.getContractData();
    private contractData = this.dataService.getSearchData();

    public contractRewards;
    public alerts =[];
    public loading:boolean = false;

    constructor(private router: Router, private dataService: DataService) { }

    ngOnInit() {
        if(!this.contractData) {
            this.router.navigate(['/'], { queryParamsHandling: 'merge' });
        } else {
            this.contractRewards = this.contractData[0];
        }
    }

    goBack() {
        this.dataService.saveContractData(null);
        this.dataService.saveSearchData(null);
        
        this.router.navigate(['/'], { queryParamsHandling: 'merge' });
    }
}
